import { KnownProjectTeamMemberDtoStatus } from '@groundfloor-platform/mgmt-service-g-sdk';
import { useCallback } from 'react';
import { useMutationUpdateTeamMember } from '../../team.queries';
import { TeamMemberDetailsActions } from '../actions/team-member-details.actions';

export function useTeamMemberStatusChange(
  setAction: (action: TeamMemberDetailsActions | null) => void,
  userId?: string,
  projectId?: string
) {
  const { mutate } = useMutationUpdateTeamMember(userId, projectId);

  const changeStatus = useCallback(
    (status: KnownProjectTeamMemberDtoStatus) => {
      mutate(status, {
        onSuccess() {
          setAction(TeamMemberDetailsActions.STATUS_CHANGE_SUCCESS);
        },
        onError() {
          setAction(TeamMemberDetailsActions.STATUS_CHANGE_ERROR);
        }
      });
    },
    [mutate, setAction]
  );

  const suspendUser = useCallback(() => changeStatus(KnownProjectTeamMemberDtoStatus.Suspended), [changeStatus]);

  const activateUser = useCallback(() => changeStatus(KnownProjectTeamMemberDtoStatus.Active), [changeStatus]);

  return { suspendUser, activateUser };
}
